import { ContentApiContentLikeRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useLikeMutation = () =>
  useBaseMutation({
    mutationFn: (req: ContentApiContentLikeRequest, config) =>
      appApiClient.contentApi.contentLike(req, config),
  })
